import React, { FC } from 'react';

const Home: FC = () => {
  return <>Home</>;
};
export default Home;
